module.exports = __webpack_public_path__ + "img/linepay1.6c719ae9.png";